import { NumericInput, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// TODO hardcoded min/max font size should be removed
const minFontSize = 5;
const maxFontSize = 60;

const StyledNumericInput = styled(NumericInput)`
  width: 70px !important;
  height: 32px;
  text-align: center;
`;

const isValid = fontSize => {
  if (fontSize == null || Number.isNaN(fontSize)) {
    return false;
  }
  if (fontSize < minFontSize || fontSize > maxFontSize) {
    return false;
  }
  return true;
};

// TODO Add the select menu with the most popular font sizes (like docs.google.com).
// - NumericInput inside Popover lacks the ability to be clickable (input looses focus before click).
// - NumericInput inside Select keeps the select appear and disappear when using increment controls.
//   Even if the values are completly separated in input and select, this keeps happening.
// - NumericInput inside Select inside ControlGroup (to move increment buttons out of the Select)
//   has bad vertical positioning, probably because of many divs wrapping the input.
// - The best way seems to be the combination of NumericInput and Select with the custom controlled
//   isOpen property, that doesn't close the popover on increment controls and on clicking inside menu.
//   This would be to much complicated now to implement.
const FontSizeSelect = ({ onChange, value }) => {
  const [inputValue, setInputValue] = useState(value);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  return (
    <Tooltip content="Font size" placement="bottom">
      <StyledNumericInput
        clampValueOnBlur
        fill
        max={maxFontSize}
        min={minFontSize}
        onValueChange={newValue => {
          // Allow user to enter any value.
          setInputValue(newValue);
          // Only values in range are passed to the parent component.
          // Using clampValueOnBlur makes this condition pass on blur and update the value.
          if (isValid(newValue)) {
            onChange(newValue);
          }
        }}
        value={inputValue}
      />
    </Tooltip>
  );
};

FontSizeSelect.defaultProps = {
  onChange: () => { },
  value: undefined,
};

FontSizeSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
};

export default FontSizeSelect;
